import { Injectable } from '@angular/core';
import { ChatSocket } from '@shared/services/websocket/custom_sockets/chat.socket';
import { ToastService } from '@shared/services/toast/toast.service';
import { NotificationSocket } from '@shared/services/websocket/custom_sockets/notification.socket';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@core/services/auth/auth.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  constructor(
    private chatSocket: ChatSocket,
    private notificationSocket: NotificationSocket,
    private authService: AuthService,
    private toast: ToastService,
    private transloco: TranslocoService
  ) {
    // this.chatSocket.disconnect();
    // this.notificationSocket.disconnect();
    // this.chatSocket.connect();
    // this.notificationSocket.connect();

    if (environment.production) {
      this.chatSocket.fromEvent('disconnect').subscribe(() => {
        console.log('You have been disconnected from sockets');
        // this.authService.signOut();
      });

      this.notificationSocket.fromEvent('disconnect').subscribe(() => {
        console.log('You have been disconnected from sockets');
        // this.authService.signOut();
      });
    }

    this.chatSocket.on('Message', (response: any) => {
      this.toast.open(
        this.transloco.translate('messages.' + response),
        'success'
      );
    });
    this.chatSocket.on('ResponseError', (response: any) => {
      this.toast.open(
        this.transloco.translate('errors.' + response.error),
        'error'
      );
    });
  }

  public connect(): void {
    // this.chatSocket.connect();
    // this.notificationSocket.connect();
  }

  public emit(
    event: string,
    data: any,
    socket_type: 'chat' | 'notification'
  ): void {
    if (socket_type == 'chat') {
      this.chatSocket.emit(event, data);
    } else {
      this.notificationSocket.emit(event, data);
    }
  }

  public on(
    event: string,
    callback: (data: any) => void,
    socket_type: 'chat' | 'notification'
  ): void {
    if (socket_type == 'chat') {
      this.chatSocket.on(event, callback);
    } else {
      this.notificationSocket.on(event, callback);
    }
  }

  public disconnect(): void {
    this.chatSocket.disconnect();
    this.notificationSocket.disconnect();
  }
}
